export enum Language {
  En = "en",
  Lt = "lt",
}

export const LANGUAGES = [Language.En, Language.Lt] as const;

export type Locale = Language;
